/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import jsYaml from "js-yaml";
import { serializeIDTToData } from "./IDTToData";

import { TBlueprintIDTNode } from "./ISchemaIDT";

export function serializeIDTToYAML(idtNode: TBlueprintIDTNode): string {
	const data = serializeIDTToData(idtNode);

	const yaml = jsYaml.dump(data, {
		skipInvalid: true,
		noRefs: true,
		quotingType: '"'
	});

	return yaml;
}
